import { fetchJob } from "actions/jobs";
import RequireData from "hooks/RequireData";
import SageErrorAlert from "kit/SageErrorAlert";
import SageScreen from "kit/SageScreen";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import jobSelector from "selectors/job";
import jobIdSelector from "selectors/jobId";
import jobLookupStatusSelector from "selectors/jobLookupStatus";
import ChangeNameDialog from "./jobDetail2/ChangeNameDialog";
import JobDetail2Info from "./jobDetail2/JobDetail2Info";
import JobDetailTaskGraphic from "./jobDetail2/JobDetailTaskGraphic";

const JobDetail2: React.FC = () => {
    const dispatch = useDispatch();

    const jobId = useSelector(jobIdSelector);

    const [job, jobStatus] = RequireData(
        jobSelector(jobId || ""),
        jobLookupStatusSelector(jobId || ""),
        fetchJob(jobId || "")
    );

    const onJobCancel = React.useCallback(() => {
        if (!jobId) {
            return;
        }
        dispatch({
            type: "com.sage.actions.jobs.ICancelJob",
            jobId: jobId || "",
        } as sage.actions.jobs.ICancelJob);
    }, [dispatch, jobId]);

    const shouldShowCancel = React.useMemo(() => {
        if (!job) {
            return false;
        }
        if (job.job_state === "CANCELED" || job.job_state === "FINISHED") {
            return false;
        }
        return true;
    }, [job]);

    if (!jobId) {
        return <Redirect to="/home" />;
    }

    if (jobStatus === "error") {
        return <SageErrorAlert />;
    } else if (!job) {
        // TODO: Shimmer loading state
        return null;
    } else {
        return (
            <>
                <ChangeNameDialog job={job} />
                <SageScreen>
                    <h3>{job.name}</h3>
                    <Dropdown>
                        <Dropdown.Toggle
                            variant="outline-secondary"
                            size="sm"
                            id="dropdown-basic"
                        >
                            Options
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                data-toggle="modal"
                                data-target="#changeNameModal"
                            >
                                Rename
                            </Dropdown.Item>
                            {shouldShowCancel && (
                                <Dropdown.Item
                                    className="text-danger"
                                    onClick={onJobCancel}
                                >
                                    Cancel
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                    <hr />
                    <JobDetail2Info job={job} />
                    <hr />
                    <JobDetailTaskGraphic jobID={job.id} />
                </SageScreen>
            </>
        );
    }
};

export default JobDetail2;
